module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Italic.e507ccf8.woff2";